import { render, staticRenderFns } from "./data5.vue?vue&type=template&id=7a3254a7&scoped=true"
import script from "./data5.vue?vue&type=script&lang=js"
export * from "./data5.vue?vue&type=script&lang=js"
import style1 from "./data5.vue?vue&type=style&index=1&id=7a3254a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3254a7",
  null
  
)

export default component.exports